import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const isAuthenticated = !!localStorage.getItem("token");

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />; // or your desired dashboard/home page
  }

  return <Outlet />;
};

export default PublicRoute;
